var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, customElement, property } from 'lit-element';
import '../terminal-dialog';
import '../terminal-details';
import '../badges';
import '../queue-element';
let TerminalElement = class TerminalElement extends LitElement {
    render() {
        const statusText = this.terminal.data.StatusText || this.terminal.data.statusText || 'No info';
        if (IS_AUTOMATENSTATUS) {
            return html `
        <span @click=${() => this.showDialog(this.terminal.data)}>
          ${this.terminal.name}
          <status-badge .value=${statusText}></status-badge>
          <terminal-details .data=${this.terminal.data}></terminal-details>
        </span>
      `;
        }
        else {
            return html `
        ${this.terminal.name}
        <status-badge .value=${statusText}></status-badge>
        ${this.queueStatistics ? html `
          <x-queue .queueStatistics=${this.queueStatistics} .terminalType=${this.terminal.type}></x-queue>` : ``}
      `;
        }
    }
    showDialog(terminalData) {
        const terminalDialog = (document.createElement('terminal-dialog'));
        terminalDialog.title = "Additional Info";
        terminalDialog.data = terminalData;
        this.renderRoot.appendChild(terminalDialog);
    }
};
TerminalElement.styles = css `:host :hover {cursor: pointer;}`;
__decorate([
    property()
], TerminalElement.prototype, "terminal", void 0);
__decorate([
    property()
], TerminalElement.prototype, "queueStatistics", void 0);
TerminalElement = __decorate([
    customElement('x-terminal')
], TerminalElement);
